import React from "react";

const DibalikLayarUIUX: React.FC = () => {
  return (
    <div className="text-justify py-4 space-y-4">
      <p>
        Keluhan terhadap aplikasi mobile seperti tampilan membingungkan, navigasi tidak intuitif,
        hingga fitur sulit ditemukan masih sering terjadi. Banyak aplikasi dengan fungsi penting akhirnya
        ditinggalkan pengguna hanya karena pengalaman penggunaan yang buruk. Hal ini
        menunjukkan bahwa UI/UX (User Interface/User Experience) memegang peran krusial dalam
        kesuksesan produk digital. Dilansir dari{" "}
        <a
          href="https://apponward.com/blogs/importance-of-ui-ux-design-in-mobile-app-development/"
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-600 underline font-medium"
        >
          ulasan Apponward mengenai UI/UX dalam pengembangan aplikasi mobile
        </a>
        , sekitar 88% pengguna enggan kembali menggunakan aplikasi setelah mengalami pengalaman yang tidak menyenangkan, 
        sehingga UI/UX berdampak langsung pada retensi dan keterlibatan pengguna.
      </p>

      <p>
        Dalam era digital saat ini, UI/UX aplikasi mobile tidak hanya berfokus pada
        estetika visual, tetapi juga kemudahan, efisiensi, dan kenyamanan interaksi pengguna.
        Tanpa perancangan berbasis riset yang matang, aplikasi berisiko gagal memenuhi kebutuhan 
        nyata pengguna meskipun memiliki fitur teknis yang canggih.  
        Menurut laman{" "}
        <a
          href="https://techies.app/blog/ui-ux-design"
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-600 underline font-medium"
        >
          Techies yang membahas kesalahan umum dalam desain UI/UX
        </a>
        , salah satu kesalahan yang kerap terjadi adalah mengabaikan riset pengguna dan umpan balik, 
        sehingga desain yang dihasilkan kurang relevan dan sulit digunakan.
      </p>

      <p>
        Tantangan utama dalam perancangan UI/UX adalah memahami perilaku dan kebutuhan 
        pengguna yang beragam. Setiap pengguna memiliki latar belakang, kebiasaan, serta 
        ekspektasi berbeda, sehingga proses riset menjadi sangat penting. Namun, keterbatasan waktu 
        dan sumber daya sering membuat tahapan riset, prototyping, dan iterasi desain tidak dilakukan 
        secara optimal, yang berdampak pada kualitas pengalaman pengguna.
      </p>

      <p>
        Selain itu, konsistensi desain pada berbagai ukuran layar dan perangkat menjadi tantangan 
        tersendiri. Ketidakkonsistenan elemen visual seperti tombol, ikon, maupun tata letak dapat 
        memicu kebingungan saat pengguna berpindah halaman. Hambatan lain juga muncul dari 
        komunikasi antara desainer dan pengembang, di mana perbedaan sudut pandang antara 
        estetika dan teknis sering menyebabkan hasil akhir tidak sesuai rancangan awal.
      </p>

      <p>
        Melalui pemahaman berbagai tantangan tersebut, desainer dan pengembang dapat merancang 
        strategi UI/UX yang lebih efektif, mulai dari riset mendalam hingga pengujian berkelanjutan. 
        Pendekatan ini diangkat dalam kompetisi <strong>Obstacle for Creating UI/UX Mobile Application</strong>,
        yang mendorong peserta menciptakan solusi UI/UX yang fungsional dan berorientasi pengguna.
        Kompetisi ini didukung oleh Indonesia Innovative Technology (IIT) bersama{" "}
        <a
          href="https://edukasi.accelist.com/"
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-600 underline font-medium"
        >
          Accelist Edukasi Indonesia (AEDU)
        </a>{" "}
        sebagai bagian dari upaya pengembangan talenta digital siap industri.
      </p>

      <p className="font-medium">👉 Cek untuk informasi lomba <span className="text-blue-600">Obstacle for Creating UI/UX Mobile Application</span> lebih lanjut</p>
    </div>
  );
};

export default DibalikLayarUIUX;
